import Qs from 'qs';
import Cookies from 'js-cookie';

export const CookieApi = Cookies.withAttributes({ domain: location.hostname, expires: 30 });

/**
 * 常量
 */
let platType;
let redirect;
if (location.search) {
  let searchObj = Qs.parse(location.search, { ignoreQueryPrefix: true });
  if (searchObj.redirect) {
    redirect = searchObj.redirect;
    localStorage.setItem('redirect', searchObj.redirect);
  } else {
    redirect = localStorage.getItem('redirect');
  }

  if (searchObj.platType) {
    platType = searchObj.platType;
    localStorage.setItem('platType', searchObj.platType);
  } else {
    platType = localStorage.getItem('platType');
  }
}
if (location.pathname.indexOf('applogin') > -1) {
  platType = 'housekeeperApp';
}
export const APP_ID = platType || 'acsecurity'; // appId
export const APP_SECRET = platType || 'acsecurity'; // appSecret
export const PLAT_TYPE = platType || 'acsecurity'; // 平台类型可能的值：用户中心后台、社区、物业、政务
export const FROM_OS = 3; //  注册平台 1:IOS，2:Android，3:web
export const redirectUrl = redirect;
console.log('redirect: ', redirectUrl);
console.log('platType22: ', PLAT_TYPE);
